import * as React from 'react';
import { cn } from '@/lib/utils';

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'animate-shimmer rounded-md bg-gradient-to-r from-gray-100 via-gray-50 to-gray-100 dark:from-[rgba(70,70,70,0.4)] dark:via-[rgba(85,85,85,0.4)] dark:to-[rgba(70,70,70,0.4)] bg-[length:200%_100%]',
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton };
